<template>
    <div class="container-fluid">
        <div
            class="herosection"
            :style="{
                backgroundImage: `url('${require('@/assets/images/HeroBg.png')}')`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                height: '224px'
            }"
            >
            <NavbarSection />
           
        </div>
    
     <!-- Main Content -->
        <div class="content-wrapper">
            <!-- Left: Gallery -->
            <div class="gallery-section">
                <PhotoGallery />
            </div>

            <div style="margin-top: 70px;" class="d-flex flex-column">
                <p><strong>Archives</strong></p>
                <div class="all-media"><a href="/photo-gallery">All Photo's</a></div>
                <ul>
                    <li 
                        v-for="(item, index) in archives"
                        :key="index"
                        class="list-group-item archive-item"
                        @click="goToArchive(item)"
                        style="cursor: pointer;"
                    >
                        {{ item.archive_date }}
                    </li>
                </ul>
            </div>
        </div>

    <FooterSection />
</div>
</template>

<script setup>
import FooterSection from '@/components/FooterSection.vue';
import PhotoGallery from '@/components/PhotoGallery.vue';
import NavbarSection from '@/components/NavbarSection.vue';
import router from '@/router';
import { ref, onMounted, onBeforeUnmount } from "vue";
import axios from 'axios';
import { useRoute } from 'vue-router'

const route = useRoute()

let base_url = process.env.VUE_APP_BASE_LIVE_URL
//let base_url = "http://localhost:8888/lltc_backend/";
const dataList = ref([]);
const title = ref('');
const description = ref('');
const image = ref('');
const logoImage = ref('');
const archives = ref('')
const dataId = ref('')

onMounted( async () => {
  dataId.value = route.params.date
  await listGallery();
  await listLogo();
  await listArchives();
});

onBeforeUnmount( async () => {
  
});

// Action methods

const listGallery = async () => {
  try {
    const response = await axios.get('/list_site_banner.php', { });
    dataList.value = response.data.data[0];
    title.value = dataList.value.title
    description.value = dataList.value.description
    image.value = `${base_url}${dataList.value.banner_image}`
    console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};
const listLogo = async () => {
  try {
    const response = await axios.get('/logo_lists.php', { });
   const logoData = response.data.data[0];
    logoImage.value = `${base_url}${logoData.banner_image}`
    console.error(response.data.message);
  } catch (error) {
    console.error(error.message);
  }
};

const listArchives = async () => {
  try {
    const response = await axios.get(`/photo_gallery_archives.php`);
    archives.value = response.data.data; 
  } catch (error) {
    console.error(error.message);
  }
};
const goToArchive = (item) => {
  router.push({
    name: 'PhotoGallery',
    query: {
      archive: item.archive_date
    }
  });
};

</script>

<style lang="scss" scoped>
.content-wrapper {
    display: flex;
    gap: 24px;
    padding: 30px 20px;
}

/* Gallery */
.gallery-section {
    flex: 3;
}

/* Archives */
.archive-section {
    flex: 1;
    background: #f8f9fa;
    padding: 16px;
    border-radius: 8px;
    height: fit-content;
}

.archive-section h4 {
    margin-bottom: 12px;
    font-size: 12px;
    font-family: Comic Sans MS;
    font-weight: bold;
}

.archive-list {
    list-style: none;
    padding: 0;
    margin: 0;
}
.all-media{

    a{
        color: #000000;
        font-size: 12px;
        font-family: Comic Sans MS;
        text-decoration: underline;
    }
}
.archive-item {
    font-size: 12px;
    font-family: Comic Sans MS;
    text-decoration: underline;
}

.archive-list button {
    background: none;
    border: none;
    padding: 2px 0;
    cursor: pointer;
    color: #0d6efd;
    font-size: 14px;
}

.archive-list button:hover {
    text-decoration: underline;
}

/* Mobile */
@media (max-width: 768px) {
    .content-wrapper {
        flex-direction: column;
    }
}
.herosection {
    border-radius: 20px;
    //background-image: url('../assets/images/HeroBg.png');
    background-size: cover;
    height: 924px;
    //padding: 10px;
    position: relative;
    width: 100%;
    padding:1.5rem 4rem 0 4rem;

    .heroWriteup {
        position: absolute;
        max-width: 750px;
        text-align: center;
        bottom: 10%;
        left: 18%;
        transform: translate(-50%, -50%);
        display: flex;
        flex-direction: column;
        gap: 10px;
        justify-content: center;
        align-items: center;
        color: white;
        //padding:0 0 0 7rem;

        h2 {
            font-size: 30px;
            font-weight: bold;
            font-family: 'Comic Sans MS';
            color: #F5F5F5 !important;
        }

        p {
            font-size: 18px;
            font-weight: bold;
            font-family: 'Comic Sans MS';

        }
    }
}

.authbuttons {
    display: flex;
    gap: 1rem;

    .login {
        background-color: #2A5237;
        border: 0px solid #0000001f;
        color: #fff;
        border-radius: 30px;
        font-family: "Open Runde", sans-serif;
        font-size: 16px;
        padding: 10px 20px;
        cursor: pointer;
        transition: 0.3s ease;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .login:hover {
        border: 2px solid #ed4e24;
    }

    .register {
        background-color: #ed4e24;
        border: 2px solid #0000001f;
        color: white;
        border-radius: 30px;
        font-family: "Open Runde", sans-serif;
        font-size: 16px;
        padding: 10px 20px;
        cursor: pointer;
        transition: 0.3s ease;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .register:hover {
        background-color: #c63d1c;
    }
}

.become-member {
    background-color: #094923;
    max-width: 80%;
    margin: auto;
    margin-top: 5rem;
    border-radius: 24px;
    padding: 20px;
    height: 479px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    position: relative;

    .bgelement-right {
        position: absolute;
        top: 0;
        right: 0;
    }

    .bgelement-left {
        position: absolute;
        bottom: 0;
        left: 0;
    }

    h2 {
        font-size: 26px;
        color: #fff;
        font-weight: 500;
        margin: 2rem 0;
        font-family: "Open Runde", sans-serif;
        text-align: center;
    }

    p {
        font-size: 16px;
        color: #fff;
        font-weight: 300;
        max-width: 569px;
        /* margin: 2rem 0; */
        font-family: "Open Runde", sans-serif;
        text-align: center;
    }

    button {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #FFFFFF29;
        border: 1px solid white;
        padding: 10px 20px;
        border-radius: 30px;
        color: white;
        gap: 10px;
        margin-top: 1rem;

        p {
            color: white;
            font-family: "Open Runde", sans-serif;
            font-size: 16px;
            cursor: pointer;
            transition: 0.3s ease;
            padding: 0%;
            margin: 0%;
        }
    }
}

.stay-connected {
    position: relative;
    height: 495px;
    padding-top: 100px;
}

.stay-connected .bg-img {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: -1;
}

.stay-connected .bg-img img {
    width: 100%;
    height: auto;
    display: block;
}

.stay-connected h2 {
    font-size: 36px;
    color: #000000;
    font-weight: 500;
    margin: auto;
    font-family: "Open Runde", sans-serif;
    text-align: center;
    max-width: 600px;
}

.stay-connected p {
    font-size: 16px;
    color: #555555;
    font-weight: 400;
    max-width: 681px;
    margin: auto;
    font-family: "Open Runde", sans-serif;
    text-align: center;
}

.subscribe-form {
    background-color: #fff;
    border: 1px solid #ED4E242E;
    width: 418px;
    height: 50px;
    border-radius: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 10px;
    padding-right: 4px;
    margin: auto;
    margin-top: 20px;

    input {
        border: none;
        outline: none;
        width: 100%;
        height: 100%;
        border-radius: 30px;
        padding-left: 8px;
        font-size: 16px;
    }

    button {
        background-color: #ED4E24;
        color: white;
        padding: 10px 20px;
        border-radius: 30px;
        border: none;
    }
}


@media (max-width: 768px) {
    .herosection {
        border-radius: 20px;
        background-image: url('../assets/images/HeroBg.png');
        background-size: cover;
        height: 624px;
        padding: 10px;
        position: relative;
        width: 100%;

        .heroWriteup {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 100%;
            text-align: center;
            display: flex;
            flex-direction: column;
            gap: 10px;
            justify-content: center;
            align-items: center;
            color: white;
            padding:0 0 0 0rem;

            h2 {
                font-size: 32px;
                /* shrink a bit for small screens */
                font-weight: 700;
                font-family: "Open Runde", sans-serif;
            }

            p {
                font-size: 16px;
                font-weight: 500;
                font-family: "Open Runde", sans-serif;
                padding: 1.2rem;
            }
        }

        .authbuttons {
            display: flex;
            flex-direction: column;
            gap: 1rem;

            .login {
                background-color: #2A5237;
                border: 0px solid #0000001f;
                color: #ffffff;
                border-radius: 30px;
                font-family: "Open Runde", sans-serif;
                font-size: 16px;
                padding: 10px 20px;
                cursor: pointer;
                transition: 0.3s ease;
            }

            .login:hover {
                border: 2px solid #ed4e24;
            }

            .register {
                background-color: #ed4e24;
                border: 2px solid #0000001f;
                color: white;
                border-radius: 30px;
                font-family: "Open Runde", sans-serif;
                font-size: 16px;
                padding: 10px 20px;
                cursor: pointer;
                transition: 0.3s ease;
            }

            .register:hover {
                background-color: #c63d1c;
            }
        }

    }

    .become-member {
        background-color: #094923;
        max-width: 100%;
        margin: auto;
        margin-top: 5rem;
        border-radius: 24px;
        padding: 20px;
        height: 479px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;

        h2 {
            font-size: 26px;
            color: #fff;
            font-weight: 500;
            margin: 2rem 0;
            font-family: "Open Runde", sans-serif;
            text-align: center;
        }

        p {
            font-size: 16px;
            color: #fff;
            font-weight: 300;
            max-width: 100%;
            /* margin: 2rem 0; */
            font-family: "Open Runde", sans-serif;
            text-align: center;
        }
    }

    .stay-connected {
        position: relative;
        height: auto;
        padding-top: 20px;
    }

    .subscribe-form {
        max-width: 100%;
    }
}
</style>
